import { render, staticRenderFns } from "./guidance.vue?vue&type=template&id=c4795f8c&scoped=true"
import script from "./guidance.vue?vue&type=script&lang=js"
export * from "./guidance.vue?vue&type=script&lang=js"
import style0 from "./guidance.vue?vue&type=style&index=0&id=c4795f8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4795f8c",
  null
  
)

export default component.exports